import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=043407e3&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"
import style0 from "./CreatePost.vue?vue&type=style&index=0&id=043407e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043407e3",
  null
  
)

export default component.exports